import renderImage from '../../../../source/importImg'
import SliderBox from '../../../ReusableComponents/SliderBox/SliderBox'
import servoPopupStyle from './ServoDetailsPopup.module.css'
import createStyle from '.././ActionsCreate.module.css'
import Hexapod from '../../../../Assets/images/Create Actions/Hexapod.png'
import humanoid from '../../../../Assets/images/ZingImage.png'
import zIndex from '@material-ui/core/styles/zIndex'

const IMAGE = {
    HEXAPOD: Hexapod,
    HUMANOID: humanoid,
}

function DeviceMotorIdImg(props) {
    const {
        showDeviceModal,
        setShowDeviceModal,
        showCloseBtn,
        DEVICEBUTTONS,
        inactiveBtnH,
        inactiveBtnseventeen,
        inactiveBtneightteen,
        isShowNewUI = 'false',
    } = props
    const connectedDevice = sessionStorage.getItem('connectedDevice')

    const largeBox = {
        top: '10vh',
        right: '0',
        height: showDeviceModal ? '60vh' : '20vh',
        width: showDeviceModal ? '471px' : '10vw',
        opacity: showDeviceModal ? 1 : 0,
        pointerEvents: showDeviceModal ? 'auto' : 'none',
        // display: showDeviceModal ? 'block' : 'none',
        // border: '1px solid red',
    }

    return (
        // showDeviceModal &&
        <>
            {
                // className={servoPopupStyle.servoPopupMain}
                <div
                    className={servoPopupStyle.motorPopupMain}
                    style={largeBox}
                >
                    <div
                        className={servoPopupStyle.servoPopupBox}
                        style={{ border: '2rem' }}
                    >
                        <img
                            className={servoPopupStyle.closeBtn}
                            style={
                                // !showCloseBtn ? { visibility: 'hidden' } : null,
                                { zIndex: '20000000' }
                            }
                            src={renderImage('clos')}
                            onClick={setShowDeviceModal}
                        />
                        <div className={servoPopupStyle.servoPopupBody}>
                            <div
                                className={
                                    createStyle[
                                        `create-${connectedDevice.toLowerCase()}`
                                    ]
                                }
                                style={{
                                    backgroundImage: `url(${
                                        IMAGE[connectedDevice.toUpperCase()]
                                    })`,
                                    height: '80vh',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    backgroundSize: '120% 100%',
                                }}
                            >
                                {
                                    DEVICEBUTTONS[
                                        `${connectedDevice.toUpperCase()}`
                                    ]
                                }
                                {/* no clue */}

                                {connectedDevice !== 'Hexapod' && (
                                    <img
                                        className={`${
                                            createStyle['sc-toggle-button']
                                        } ${
                                            createStyle[
                                                `sc-btn-H-${isShowNewUI}`
                                            ]
                                        }`}
                                        src={inactiveBtnH}
                                    />
                                )}

                                {connectedDevice === 'Hexapod' && (
                                    <>
                                        <img
                                            className={`${
                                                createStyle['sc-toggle-button']
                                            } ${
                                                createStyle[
                                                    `sc-btn-${connectedDevice.toLowerCase()}-seventeen-${isShowNewUI}`
                                                ]
                                            }`}
                                            src={inactiveBtnseventeen}
                                        />
                                        <img
                                            className={`${
                                                createStyle['sc-toggle-button']
                                            } ${
                                                createStyle[
                                                    `sc-btn-${connectedDevice.toLowerCase()}-eighteen-${isShowNewUI}`
                                                ]
                                            }`}
                                            src={inactiveBtneightteen}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default DeviceMotorIdImg
